import { render, staticRenderFns } from "./RepresentanteLegal.vue?vue&type=template&id=1bd0818a&scoped=true&"
import script from "./RepresentanteLegal.vue?vue&type=script&lang=js&"
export * from "./RepresentanteLegal.vue?vue&type=script&lang=js&"
import style0 from "./RepresentanteLegal.vue?vue&type=style&index=0&id=1bd0818a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd0818a",
  null
  
)

export default component.exports